/// <reference path='../../interfaces/interfaces.d.ts' />

import * as _ from 'lodash';

'use strict';

class OrgPropSelectDirective {

    public restrict;
    public require;
    public scope;
    public template;
    public replace;

    constructor(private Orgs: IOrgsService) {
        this.restrict = 'E';
        this.scope = {
            model: '=',
            schema: '='
        };
        this.replace = true;
        this.template = `
            <select class="form-control" ng-model='model' ng-options='e for e in list'></select>`
    }

    public link = (scope: any) => {
        scope.loaded = false;
        scope.list = []

        this.Orgs.getOrgFromCache((org) => {
            if (!org) { return }
            let path = scope.schema.format.substring(5).split('.')
            let fn = (path, object) => {
                if (object === undefined) {
                    return []
                } else if (path.length <= 0) {
                    return [object]
                } else if (path[0] == '*') {
                    return [].concat.apply([], object.map(i => fn(path.slice(1), i)))
                } else {
                    return fn(path.slice(1), object[path[0]])
                }
            }
            scope.list = fn(path, org)
            scope.loaded = true;
        });
    };

    public static DirectiveFn(Orgs: IOrgsService): OrgPropSelectDirective {
        return new OrgPropSelectDirective(Orgs);
    }
}

OrgPropSelectDirective.DirectiveFn.$inject = ['Orgs'];

angular.module('beneple.global')
    .directive('orgPropSelect', OrgPropSelectDirective.DirectiveFn);



// WEBPACK FOOTER //
// ./frontend/scripts/schemaForm/directives/org_prop_select.directive.ts